export enum DelegationAddFromAllMileagesRequestVehicleType {
  COMPANY_OWNED = "COMPANY_OWNED",
  CAR_GT_900CM3 = "CAR_GT_900CM3",
  CAR_LE_900CM3 = "CAR_LE_900CM3",
  MOTORCYCLE = "MOTORCYCLE",
  MOPED = "MOPED",
}

export type DelegationAddFromAllMileagesRequestQueryParams = {
  cargoCompanyName?: string;
  companyId?: string;
  dateSince?: Date;
  dateTo?: Date;
  humanId?: number;
  mileageNumber?: string;
  workerName?: string;
  cardNumber?: string;
  address?: string[];
  startAddress?: string[];
  midAddress?: string[];
  endAddress?: string[];
  distanceMax?: number;
  distanceMin?: number;
  vehicleType?: DelegationAddFromAllMileagesRequestVehicleType;
};

type DelegationAddFromAllMileagesRequest = {
  companyId?: string;
  dateSince?: Date;
  dateTo?: Date;
  cargoCompanyName?: string;
  humanId?: number;
  mileageNumber?: string;
  workerName?: string;
  cardNumber?: string;
  address?: string[];
  startAddress?: string[];
  midAddress?: string[];
  endAddress?: string[];
  distanceMax?: number;
  distanceMin?: number;
  vehicleType?: DelegationAddFromAllMileagesRequestVehicleType;
};

export default DelegationAddFromAllMileagesRequest;
